import { createApp, markRaw } from 'vue'
import { createPinia } from 'pinia'

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from '@/App.vue'
import router from '@/router'

import Vue3Toastify from 'vue3-toastify'

import '@/assets/main.scss'
import 'bootstrap/dist/js/bootstrap.min.js'
import '@popperjs/core/dist/cjs/popper.js'
import 'animate.css/animate.min.css'

import { tooltip } from "@/plugins/tooltip.js"
import { popover } from "@/plugins/popover.js"

const app = createApp( App )

const pinia = createPinia()
pinia.use( piniaPluginPersistedstate )
pinia.use( ( { store } ) => {
  store.router = markRaw( router )
})

app.use( pinia )
app.use( router )
app.use( Vue3Toastify, {
  clearOnUrlChange: false,
  theme: 'colored',
  position: 'top-left',
  style: {
    width: '450px'
  }
})

app.directive( 'tooltip', tooltip )
app.directive( 'popover', popover )

app.mount( '#app' )
